var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c(
              "form",
              { attrs: { action: "" }, on: { submit: _vm.requestAnalitics } },
              [
                _c("div", [
                  _c("h5", [_vm._v("Рейтинг менеджеров")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex date_selector_div" }, [
                    _c("div", { staticClass: "mr-1 rangePicker" }, [
                      _c(
                        "div",
                        [
                          _c("date-range-picker", {
                            ref: "picker",
                            attrs: {
                              startDate: _vm.startDate,
                              opens: "right",
                              ranges: _vm.ranges,
                              "locale-data": _vm.date_locale,
                            },
                            model: {
                              value: _vm.dateRange,
                              callback: function ($$v) {
                                _vm.dateRange = $$v
                              },
                              expression: "dateRange",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pt-1" },
                        [
                          _c("LoadingButton", {
                            staticClass: "btn btn-info",
                            attrs: {
                              title: "Статистика",
                              loading: _vm.loading,
                              type: "button",
                              color: _vm.$constants.PRIMARY_COLOR,
                              onClick: () => _vm.managersStats(),
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex-grow-1" }, [
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [
                          _c("multiselect", {
                            staticClass: "mr-1",
                            attrs: {
                              options: _vm.allProjects,
                              multiple: true,
                              label: "name",
                              "track-by": "name",
                              placeholder: "Выберите проект",
                              "select-label": "Выбрать",
                              "deselect-label": "Убрать проект",
                            },
                            model: {
                              value: _vm.selected_projects,
                              callback: function ($$v) {
                                _vm.selected_projects = $$v
                              },
                              expression: "selected_projects",
                            },
                          }),
                          _vm._v(" "),
                          _c("multiselect", {
                            attrs: {
                              options: _vm.AgentsOptions,
                              multiple: false,
                              label: "name",
                              "track-by": "name",
                              placeholder: "Выберите менеджера",
                              "select-label": "Выбрать",
                              "deselect-label": "Убрать менеджера",
                            },
                            model: {
                              value: _vm.selected_agent,
                              callback: function ($$v) {
                                _vm.selected_agent = $$v
                              },
                              expression: "selected_agent",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._m(0),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("pulse-loader", {
          staticStyle: { "text-align": "center" },
          attrs: { loading: _vm.loading, color: _vm.color },
        }),
      ],
      1
    ),
    _vm._v(" "),
    !_vm.loading && _vm.managersStat
      ? _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "alert alert-info" }, [
              _c("p", [
                _c("span", [
                  _vm._v("Закрыто: "),
                  _c("strong", [_vm._v(_vm._s(_vm.totalStat.closed.total))]),
                  _vm._v(" (" + _vm._s(_vm.totalStat.closed.percent) + "%)"),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v("Отмена М: "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.totalStat.rejected_m.total)),
                  ]),
                  _vm._v(
                    " (" + _vm._s(_vm.totalStat.rejected_m.percent) + "%)"
                  ),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v("Отмена К: "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.totalStat.rejected_r.total)),
                  ]),
                  _vm._v(
                    " (" + _vm._s(_vm.totalStat.rejected_r.percent) + "%)"
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("table", { staticClass: "table mt-1 table-sm table-hover" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(
                  _vm.getSorted(_vm.engadgedUsers, "name"),
                  function (u, i) {
                    return _c(
                      "tr",
                      [
                        _c("td", [_vm._v(_vm._s(i + 1))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "(" +
                              _vm._s(u.id || "без ID") +
                              ") " +
                              _vm._s(u.name || "не указан")
                          ),
                        ]),
                        _vm._v(" "),
                        [
                          _c("td", { staticClass: "block_1" }, [
                            _vm._v(
                              _vm._s(_vm.managersStat[u.id].closed.orders)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "block_1" }, [
                            _vm._v(
                              _vm._s(
                                _vm.managersStat[
                                  u.id
                                ].closed.sum.toLocaleString("ru-RU")
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "block_1" }, [
                            _vm._v(
                              _vm._s(
                                _vm.managersStat[
                                  u.id
                                ].closed.bill.toLocaleString("ru-RU")
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "block_1" }, [
                            _vm._v(
                              _vm._s(_vm.managersStat[u.id].closed.percent)
                            ),
                          ]),
                        ],
                        _vm._v(" "),
                        [
                          _c("td", { staticClass: "block_2" }, [
                            _vm._v(
                              _vm._s(_vm.managersStat[u.id].rejected_m.orders)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "block_2" }, [
                            _vm._v(
                              _vm._s(
                                _vm.managersStat[
                                  u.id
                                ].rejected_m.sum.toLocaleString("ru-RU")
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "block_2" }, [
                            _vm._v(
                              _vm._s(_vm.managersStat[u.id].rejected_m.percent)
                            ),
                          ]),
                        ],
                        _vm._v(" "),
                        [
                          _c("td", { staticClass: "block_3" }, [
                            _vm._v(
                              _vm._s(_vm.managersStat[u.id].rejected_r.orders)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "block_3" }, [
                            _vm._v(
                              _vm._s(
                                _vm.managersStat[
                                  u.id
                                ].rejected_r.sum.toLocaleString("ru-RU")
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "block_3" }, [
                            _vm._v(
                              _vm._s(_vm.managersStat[u.id].rejected_r.percent)
                            ),
                          ]),
                        ],
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.managersStat[u.id].total.bill.toLocaleString(
                                "ru-RU"
                              )
                            )
                          ),
                        ]),
                      ],
                      2
                    )
                  }
                ),
                0
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.loading && _vm.statData
      ? _c("div", [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-3" }, [
                  _c("p", [
                    _vm._v("Всего поступило: "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.totalStatData.site.totalOrders)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Обработано: "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.totalStatData.site.released) +
                          "\n              (" +
                          _vm._s(
                            Math.round(
                              (_vm.totalStatData.site.released * 100) /
                                _vm.totalStatData.site.totalOrders
                            )
                          ) +
                          "%)"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Отменено: "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.totalStatData.site.rejected) +
                          "\n              (" +
                          _vm._s(
                            Math.round(
                              (_vm.totalStatData.site.rejected * 100) /
                                _vm.totalStatData.site.totalOrders
                            )
                          ) +
                          "%)"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Не обработано:\n              "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.totalStatData.site.totalOrders -
                            _vm.totalStatData.site.released -
                            _vm.totalStatData.site.rejected
                        ) +
                          "\n                (" +
                          _vm._s(
                            Math.round(
                              ((_vm.totalStatData.site.totalOrders -
                                _vm.totalStatData.site.released -
                                _vm.totalStatData.site.rejected) *
                                100) /
                                _vm.totalStatData.site.totalOrders
                            )
                          ) +
                          "%)"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Средний чек: "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          Math.round(
                            _vm.statData.site_income_bill /
                              _vm.totalStatData.site.released
                          ).toLocaleString("ru-RU")
                        )
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-9" },
                  [
                    _c("highcharts", {
                      attrs: { options: _vm.siteOrderChartData },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-3" }, [
                  _c("p", [
                    _vm._v("Всего создано: "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.totalStatData.manual.totalOrders)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Обработано: "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.totalStatData.manual.released) +
                          "\n              (" +
                          _vm._s(
                            Math.round(
                              (_vm.totalStatData.manual.released * 100) /
                                _vm.totalStatData.manual.totalOrders
                            )
                          ) +
                          "%)"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Отменено: "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.totalStatData.manual.rejected) +
                          "\n              (" +
                          _vm._s(
                            Math.round(
                              (_vm.totalStatData.manual.rejected * 100) /
                                _vm.totalStatData.manual.totalOrders
                            )
                          ) +
                          "%)"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Не обработано: "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.totalStatData.manual.totalOrders -
                            _vm.totalStatData.manual.released -
                            _vm.totalStatData.manual.rejected
                        ) +
                          "\n              (" +
                          _vm._s(
                            Math.round(
                              ((_vm.totalStatData.manual.totalOrders -
                                _vm.totalStatData.manual.released -
                                _vm.totalStatData.manual.rejected) *
                                100) /
                                _vm.totalStatData.site.totalOrders
                            )
                          ) +
                          "%)"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Средний чек: "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          Math.round(
                            _vm.statData.manual_bill /
                              _vm.totalStatData.manual.released
                          ).toLocaleString("ru-RU")
                        )
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-9" },
                  [
                    _c("highcharts", {
                      attrs: { options: _vm.manualOrderChartData },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-3" }, [
                  _c("p", [
                    _vm._v("Обработано: "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.totalStatData.manual.released +
                            _vm.totalStatData.site.released
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Всего отказов: "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.totalStatData.rejected_by_runner) +
                          " (" +
                          _vm._s(
                            Math.round(
                              (_vm.totalStatData.rejected_by_runner * 100) /
                                (_vm.totalStatData.manual.released +
                                  _vm.totalStatData.site.released)
                            )
                          ) +
                          "%)"
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-9" },
                  [
                    _c("highcharts", {
                      attrs: { options: _vm.rejectedByRunners },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          false && Object.keys(_vm.orders).length
            ? _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "table",
                        { staticClass: "table table-hover" },
                        [
                          _vm._m(2),
                          _vm._v(" "),
                          _vm._l(_vm.list_of_agents, function (data, index) {
                            return _c(
                              "tbody",
                              { key: data.value },
                              [
                                _c("tr", [
                                  _c("td", { attrs: { colspan: "5" } }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(data.name) +
                                        "\n                "
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.orders[data.value],
                                  function (o, date_str) {
                                    return _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(date_str) +
                                            " (" +
                                            _vm._s(o.day) +
                                            ")"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [_vm._v(_vm._s(o[9999]))]),
                                      _vm._v(" "),
                                      _c("td", [_vm._v(_vm._s(o[0]))]),
                                    ])
                                  }
                                ),
                                _vm._v(" "),
                                _c("tr", { staticClass: "total_line" }, [
                                  _c("td", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(data.name) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.countTotal(
                                          _vm.orders[data.value],
                                          9999
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.countTotal(
                                          _vm.orders[data.value],
                                          0
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.countTotal(_vm.orders[data.value])
                                      )
                                    ),
                                  ]),
                                ]),
                              ],
                              2
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "table",
                        { staticClass: "table table-hover" },
                        [
                          _vm._m(3),
                          _vm._v(" "),
                          _vm._l(_vm.list_of_agents, function (data, index) {
                            return _c(
                              "tbody",
                              { key: data.value },
                              [
                                _c("tr", [
                                  _c("td", { attrs: { colspan: "5" } }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(data.name) +
                                        "\n                "
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.orders_summ[data.value],
                                  function (o, date_str) {
                                    return _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(date_str) +
                                            " (" +
                                            _vm._s(
                                              _vm.orders[data.value][date_str]
                                                .day
                                            ) +
                                            ")"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [_vm._v(_vm._s(o[9999]))]),
                                      _vm._v(" "),
                                      _c("td", [_vm._v(_vm._s(o[0]))]),
                                    ])
                                  }
                                ),
                                _vm._v(" "),
                                _c("tr", { staticClass: "total_line" }, [
                                  _c("td", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(data.name) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.countTotal(
                                          _vm.orders_summ[data.value],
                                          9999
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.countTotal(
                                          _vm.orders_summ[data.value],
                                          0
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.countTotal(
                                          _vm.orders_summ[data.value]
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ],
                              2
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pt-1" }, [
      _c(
        "button",
        { staticClass: "btn btn-outline-info", attrs: { type: "submit" } },
        [_vm._v("Показать статистику менеджера")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Менеджер")]),
        _vm._v(" "),
        _c("th", { staticClass: "block_1" }, [_vm._v("Закрыто")]),
        _vm._v(" "),
        _c("th", { staticClass: "block_1" }, [_vm._v("Сумма")]),
        _vm._v(" "),
        _c("th", { staticClass: "block_1" }, [_vm._v("Чек")]),
        _vm._v(" "),
        _c("th", { staticClass: "block_1" }, [_vm._v("%")]),
        _vm._v(" "),
        _c("th", { staticClass: "block_2" }, [_vm._v("Отмена М")]),
        _vm._v(" "),
        _c("th", { staticClass: "block_2" }, [_vm._v("Сумма")]),
        _vm._v(" "),
        _c("th", { staticClass: "block_2" }, [_vm._v("%")]),
        _vm._v(" "),
        _c("th", { staticClass: "block_3" }, [_vm._v("Отмена К")]),
        _vm._v(" "),
        _c("th", { staticClass: "block_3" }, [_vm._v("Сумма")]),
        _vm._v(" "),
        _c("th", { staticClass: "block_3" }, [_vm._v("%")]),
        _vm._v(" "),
        _c("th", {}, [_vm._v("Чек")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Дата")]),
        _vm._v(" "),
        _c("th", [_vm._v("Ручные")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сайт")]),
        _vm._v(" "),
        _c("th", [_vm._v("Итого")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Дата")]),
        _vm._v(" "),
        _c("th", [_vm._v("Ручные")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сайт")]),
        _vm._v(" "),
        _c("th", [_vm._v("Итого")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }